// src/context/VehiculoViewerContext.jsx
import React, { createContext, useContext, useState, useCallback } from "react";
import VehiculoViewerDialog from "../components/VehiculoViewerDialog";

const VehiculoViewerContext = createContext(null);

export const VehiculoViewerProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [placa, setPlaca] = useState(null);

  const openVehiculoViewer = useCallback((valorPlaca) => {
    if (!valorPlaca) return;
    setPlaca(String(valorPlaca).trim());
    setOpen(true);
  }, []);

  const closeVehiculoViewer = useCallback(() => {
    setOpen(false);
    setPlaca(null);
  }, []);

  return (
    <VehiculoViewerContext.Provider value={{ openVehiculoViewer }}>
      {children}
      <VehiculoViewerDialog open={open} onClose={closeVehiculoViewer} placa={placa} />
    </VehiculoViewerContext.Provider>
  );
};

export const useVehiculoViewer = () => {
  const ctx = useContext(VehiculoViewerContext);
  if (!ctx) {
    throw new Error("useVehiculoViewer debe usarse dentro de VehiculoViewerProvider");
  }
  return ctx;
};
